module.exports = __webpack_public_path__ + "img/account.694bfb0e.svg";